<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section v-menu-permission="'list'" class="app-content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" aria-labelledby="headingOne" class="collapse show"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter ref="emListFilter" :entity="modelName"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesInventoryMaterialDispatchingResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" aria-labelledby="headingTwo" class="collapse show"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table ref="emTable"
                                      :entity="modelName" :inlineActionsDisabled="prop_inline!=='1'"
                                      enable-field-batch-edit
                                      accept-batch-edit-fields="dispatchStatus,sourceLocation,storageType,sourceBin"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow">
                                <template #left-header>
                                    <em-button :busy="onComplete"
                                               :disabled="actionDisabled('select')"
                                               :showName="true"
                                               confirm-text="将通知库房人员下架，确认已核查？"
                                               custom-label="确认已核查"
                                               type="search"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="confirmChecked()"
                                    >
                                    </em-button>
                                    <em-button :busy="onOffShelf"
                                               :disabled="actionDisabled('select')"
                                               :showName="true"
                                               confirm-text="确认执行SAP下架？"
                                               custom-label="执行SAP下架"
                                               type="search"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="executeOffShelf()"
                                    >
                                    </em-button>
                                    <b-button
                                        :disabled="actionDisabled('select')"
                                        size="sm"
                                        variant="outline-primary"
                                        @click="openConfirmOutput()"
                                    >
                                        确认出库
                                    </b-button>
                                    <!-- <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-check"
                                        :disabled="false"
                                        custom-label="扫码点件"
                                        :showName = "true"
                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                        @click="openCountDialog()"
                                    >
                                    </em-button> -->
                                    <b-button
                                        :disabled="actionDisabled('select')"
                                        size="sm"
                                        variant="outline-primary"
                                        @click="openConfirm()"
                                    >
                                        确认配送
                                    </b-button>
                                    <b-button
                                        :disabled="actionDisabled('select')"
                                        size="sm"
                                        variant="outline-primary"
                                        @click="printLabel()"
                                    >
                                        打印标签
                                    </b-button>
                                    <!--                  <em-button type="search"-->
                                    <!--                             :disabled="actionDisabled('selectOne')"-->
                                    <!--                             custom-label="DN物料下架"-->
                                    <!--                             :showName="true"-->
                                    <!--                             v-bind:class="'btn btn-success btn-sm'"-->
                                    <!--                             :busy="onDnOffShelf"-->
                                    <!--                             @click="executeDnOffShelf()"-->
                                    <!--                             confirm-text="确认下架？"-->
                                    <!--                  >-->
                                    <!--                  </em-button>-->
                                    <!-- <em-button type="search"
                                               :disabled="actionDisabled('select')"
                                               custom-label="DN物料过账"
                                               :showName="true"
                                               v-bind:class="'btn btn-success btn-sm'"
                                               :busy="onDnPosting"
                                               @click="executeDnPost()"
                                               confirm-text="确认过账？"
                                    >
                                    </em-button> -->
                                    <em-button :disabled="actionDisabled('select')"
                                               :showName="true"
                                               custom-label="更新需求配送时间"
                                               type="search"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="updateTimeVisible = true"
                                    >
                                    </em-button>
                                    <em-button :disabled="actionDisabled('select')"
                                               :showName="true"
                                               custom-label="更新备注"
                                               type="search"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="updateRemarkVisible = true"
                                    >
                                    </em-button>
                                    <em-button :disabled="actionDisabled('select')"
                                               :showName="true"
                                               custom-label="更新需求配送工位"
                                               type="search"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="locationSelectModalVisible = true"
                                    >
                                    </em-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <el-dialog :close-on-click-modal='false' :visible.sync="confirmOutputDialogVisible" title="确认出库"
                   append-to-body
                   @close='clearConfirmOutputForm'>
            <el-form ref="confirmOutputForm" :model="confirmOutputForm" :rules="confirmOutputRules" label-width="auto">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="已占容量" prop="strCapacity">
                            <el-input v-model="confirmOutputForm.strCapacity">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer">
                <el-button @click="confirmOutputDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmOutput">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal='false' :visible.sync="confirmDialogVisible" title="确认配送"
                   append-to-body
                   @close='clearDispatchForm'>
            <el-form ref="dispatchForm" :model="dispatchForm" :rules="rules" label-width="auto">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="配送工位" prop="location">
                            <el-input v-model="dispatchForm.location">
                                <el-button slot="append" icon="el-icon-camera" @click="scanLocation"></el-button>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <el-dialog :center="true" :close-on-click-modal='false' :visible.sync="scannerVisible" append-to-body
                       title="扫一扫"
                       @close="closeBinScannerDialog">
                <qr-code-scanner ref="binScanner" @getCodeData='getCodeData'>
                </qr-code-scanner>
            </el-dialog>

            <div slot="footer">
                <el-button @click="confirmDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="completeDispatch">确定</el-button>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal='false' :visible.sync="countDialogVisible" title="扫码点件" width="50%"
                   append-to-body
                   @close='clearMaterialList'>
            <el-table :data="materialList" empty-text="请点击打开扫码框扫码" max-height="285px" style="width:100%">
                <el-table-column label="工单号" prop="orderCode" width="200"></el-table-column>
                <el-table-column label="物料号" prop="materialCode" width="200"></el-table-column>
                <el-table-column label="工序" prop="operationSeq" width="50"></el-table-column>
                <el-table-column label="配送数量" prop="quantity" width="150"></el-table-column>
            </el-table>
            <el-dialog :center="true" :close-on-click-modal='false' :visible.sync="openScanner" append-to-body
                       title="扫一扫"
                       @close="closeCountScannerDialog">
                <qr-code-scanner ref="countScanner" @getCodeData='getMaterialCodeData'>
                </qr-code-scanner>
            </el-dialog>
            <div slot="footer" class="dialog-footer">
                <el-button @click="countDialogVisible = false">取 消</el-button>
                <el-button @click="openScannerDialog()">打开扫码框</el-button>
                <el-button :disabled="materialList.length == 0" type="primary" @click="confirmCount('scan')">确认点件
                </el-button>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal='false' :visible.sync="updateTimeVisible" title="更新需求配送时间" width="30%"
                   append-to-body
                   @close='clearUpdateTime'>
            <el-form ref="updateTimeForm" :model="updateForm" :rules="updateTimeRule" label-width="auto">
                <el-form-item label="需求配送时间" prop="dispatchPlanTime">
                    <el-date-picker v-model="updateForm.dispatchPlanTime" placeholder="选择日期时间" type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="updateTimeVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateDispatchTime()">确认</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal='false' :visible.sync="updateRemarkVisible" title="更新备注" width="30%"
                   append-to-body
                   @close='clearUpdateRemark'>
            <el-form ref="updateRemarkForm" :model="updateForm" :rules="updateRemarkRule" label-width="auto">
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="updateForm.remark" type="textarea"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="updateRemarkVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateRemark()">确认</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal='false' :visible.sync="updateLocationVisible" title="更新需求配送工位"
                   append-to-body
                   width="30%" @close='clearUpdateLocation'>
            <el-form ref="updateLocationForm" :model="updateLocationForm" :rules="updateLocationRule"
                     label-width="auto">

                <el-form-item label="工位ID" prop="locationId">
                    <el-input v-model="updateLocationForm.locationId" :disabled="true">
                        <el-button slot="append" type="success" @click="locationSelectModalVisible=true">选择工位
                        </el-button>
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="updateLocationVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateLocation()">确认</el-button>
            </div>
        </el-dialog>

        <b-modal v-model="locationSelectModalVisible" scrollable title="选择工位" @ok="setUpdateLocation">
            <location-tree ref="locationTree"></location-tree>
        </b-modal>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
// Author Lin
// Date 2021-08-02 10:05:28

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";
import qrCodeScanner from "@/components/QRCode/QRCodeScannerForInventory"
import commonViewsUtil from "@/utils/commonViewsUtil";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";
import LocationTree from "@/components/em/EmBusiness/locationTree";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import emCustomVuexMixin from "@/mixin/em/customVuex";

export default {
    components: {qrCodeScanner, LocationTree},
    name: "sithMesInventoryMaterialDispatchingListView",
    mixins: [emCommonListMixin, emCommonApiMixin, emTableCheckedMixin, emCommonGotoMixin, emCustomVuexMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            confirmDialogVisible: false,
            //确认出库dialog是否显示
            confirmOutputDialogVisible: false,
            scannerVisible: false,
            //确认出库FORM
            confirmOutputForm: {
                dispatchId: '',
                // sourceBin: '',
                strCapacity: ''
            },
            confirmOutputRules: {
                strCapacity: [{required: true, message: '请输入已占容量'}]
            },
            dispatchForm: {
                location: ''
            },
            rules: {
                location: [{required: true, message: '请输入或扫码录入工位'}]
            },
            onComplete: false,
            onOffShelf: false,
            onCount: false,
            countDialogVisible: false,
            materialList: [],
            openScanner: false,
            onDnOffShelf: false,
            onDnPosting: false,
            updateTimeVisible: false,
            updateRemarkVisible: false,
            updateForm: {
                dispatchPlanTime: '',
                remark: ''
            },
            updateTimeRule: {dispatchPlanTime: [{required: true, message: '请选择时间'}]},
            updateRemarkRule: {remark: [{required: true, message: '请输入备注'}]},
            updateLocationRule: {remark: [{required: true, message: '请选择工位'}]},
            updateLocationForm: {
                locationId: ''
            },
            locationSelectModalVisible: false,
            updateLocationVisible: false,
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        checkedItems() {
            //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
            return this.$store.state[this.modelName]["checkedItems"];
        },
        selectIds() {
            //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
            return this.$store.state[this.modelName]["checkedItems"].join(",");
        },
        entityBaseUrl() {
            return `${this.$_emApiMixin_entityBaseApi(this.modelName)}/`
        },
    },
    methods: {
        initFilter() {
            let queryStartDate = new Date();
            let queryEndDate = new Date();

            queryStartDate.setHours(0, 0, 0, 0);
            queryEndDate.setHours(23, 59, 59, 999);
            // 获取当前日期的时间戳
            let currentTime = queryStartDate.getTime();
            // 计算 30 天前的日期
            let sevenDaysAgo = currentTime - (30 * 24 * 60 * 60 * 1000);
            // 设置查询开始日期为 30 天前
            queryStartDate.setTime(sevenDaysAgo);
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('dispatchPlanTimeRteFilter', queryStartDate.getTime());
            //this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('dispatchPlanTimeLteFilter', queryEndDate.getTime());
        },
        actionDisabled(type) {
            // 删除按钮在一条记录都没选的时候禁用
            if (type === "select") {
                return this.checkedItems && this.checkedItems.length === 0;
            }
            // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
            else if (type === "selectOne") {
                return this.checkedItems && this.checkedItems.length !== 1;
            }
        },
        openConfirm() {
            this.dispatchForm.location = this.checkedRows[0].stationCode;
            this.confirmDialogVisible = true;
        },
        openConfirmOutput() {
            this.confirmOutputDialogVisible = true;
        },
        confirmOutput() {
            if (this.checkedItems) {
                let compare = null;
                console.log(this.checkedRows)
                for (let item of this.checkedRows) {
                    let tempBinStr = item.sourceBin;
                    if (!tempBinStr) {
                        this.$message.warning('所选条目没有Bin位，请检查！')
                        return;
                    }
                    let strings = tempBinStr.split(',');
                    if (strings) {
                        let tempList = [];
                        for (let str of strings) {
                            let split = str.split(':');
                            tempList.push(split[0]);
                        }
                        tempList.sort();
                        let join = tempList.join(',');
                        if (compare && compare !== join) {
                            this.$message.error('所选条目的Bin位不相同，请检查！')
                            return;
                        } else {
                            compare = join;
                        }
                    }
                }
            }

            let self = this;
            this.$refs["confirmOutputForm"].validate(valid => {
                if (valid) {
                    let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/confirmOutput?ids=${this.selectIds}&occupiedCapacity=${self.confirmOutputForm.strCapacity}`
                    this.$_emApiMixin_post(url, self.confirmOutputForm)
                        .then(response => {
                            if (response.status === 200) {
                                self.$message({
                                    message: "确认出库成功",
                                    type: "success",
                                });
                            } else {
                                self.$message({
                                    message: `response.message`,
                                    type: "error",
                                });
                            }
                        }).finally(
                        () => {
                            self.confirmOutputDialogVisible = false;
                            self.$refs.emListFilter.doQuery();
                        }
                    );
                } else {
                    self.$message({
                        message: "数据不完整",
                        type: "error",
                    });
                    return;
                }
            });
        },
        printLabel() {
            let url = `${this.entityBaseUrl}getInventoryPrintList?ids=${this.$store.state[this.modelName]["checkedItems"].join(",")}`
            this.$_emApiMixin_post(url, {})
                .then(response => {
                    this.$router.push({
                        name: "sithMesInventoryItemPrint",
                        query: response.data,
                    });
                })
        },
        clearDispatchForm() {
            this.dispatchForm.location = '';
            this.$refs['dispatchForm'].resetFields();
        },
        clearConfirmOutputForm() {
            this.confirmOutputForm.strCapacity = '';
            this.$refs["confirmOutputForm"].resetFields();
        },
        scanLocation() {
            this.scannerVisible = true;
            setTimeout(() => {
                this.$refs.binScanner.openCamera('');
            }, 500);
        },
        closeBinScannerDialog() {
            this.$refs.binScanner.closeCamera();
            this.$refs.binScanner.resetOutputData();
            this.scannerVisible = false;
        },
        getCodeData(data) {
            this.scannerVisible = false;
            let self = this;
            let jsonObj;
            //检验二维码的数据格式
            try {
                jsonObj = JSON.parse(data);
            } catch (error) {
                self.$message({
                    message: "无效的二维码",
                    type: "error",
                });
                return;
            }

            this.dispatchForm.location = jsonObj['Storage Bin'];
        },
        completeDispatch() {
            let self = this;
            let url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryMaterialDispatching")}/completeDispatch?ids=${this.selectIds}&location=${self.dispatchForm.location}`;
            this.$_emApiMixin_post(url, {})
                .then((request) => {
                    if (request.status === 200) {
                        self.$message({
                            message: "配送成功",
                            type: "success",
                        });

                        self.$refs.emListFilter.doQuery();
                    } else {
                        self.$message({
                            message: "配送失败",
                            type: "error",
                        });
                    }
                }).finally(() => {
                this.confirmDialogVisible = false;
            })
        },
        confirmChecked() {
            this.onComplete = true;
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/confirmChecked?ids=${this.selectIds}`
            this.$_emApiMixin_post(url, {})
                .then(response => {
                    commonViewsUtil.showSuccess(this, "确认完毕");
                    this.$refs.emListFilter.doQuery()
                })
                .finally(() => this.onComplete = false)
        },
        executeOffShelf() {
            this.onOffShelf = true;
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/executeOffShelf?ids=${this.selectIds}`
            this.$_emApiMixin_post(url, {})
                .then(response => {
                    if (response.status === 200) {
                        commonViewsUtil.showSuccess(this, "SAP下架完成");
                        this.$refs.emListFilter.doQuery()
                    } else {
                        commonViewsUtil.showWarning(this, "SAP下架失败");
                    }
                })
                .finally(() => this.onOffShelf = false)
        },
        confirmCount(type) {
            let ids;
            if (type === 'manual') {
                this.onCount = true;
                ids = this.selectIds;
            } else if (type === 'scan') {
                ids = this.materialList.map(mat => {
                    return mat.id
                });
            }
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/confirmCount?ids=${ids}`
            this.$_emApiMixin_post(url, {})
                .then(response => {
                    commonViewsUtil.showSuccess(this, "已点件");
                    this.$refs.emListFilter.doQuery()
                })
                .finally(() => this.onCount = false)
        },
        openCountDialog() {
            this.countDialogVisible = true;
        },
        clearMaterialList() {
            this.materialList = [];
        },
        openScannerDialog() {
            this.openScanner = true;
            setTimeout(() => {
                this.$refs.countScanner.openCamera('');
            }, 500);
        },
        closeCountScannerDialog() {
            this.$refs.countScanner.closeCamera();
            this.$refs.countScanner.resetOutputData();
            this.openScanner = false;
        },
        getMaterialCodeData(data) {
            console.log("get qr code data:" + data);
            this.openScanner = false;
            let self = this;
            //检验二维码的数据格式
            try {
                var obj = JSON.parse(data);
                var materialCode = obj['物料号'];
                var orderCode = obj['工单号'];
            } catch (error) {
                self.$message({
                    message: "无效的二维码",
                    type: "error",
                });
                return;
            }

            let _url = `${self.$_emApiMixin_entityBaseApi("sithMesInventoryMaterialDispatching")}/`;
            _url += `findMaterialForCount?materialCode=${materialCode}&orderCode=${orderCode}`;
            self.$_emApiMixin_get(_url, {})
                .then((value) => {
                    var arr = Object.keys(value);
                    if (arr.length != 0) {
                        console.log("value======" + JSON.stringify(value));
                        self.materialList = [];
                        self.materialList.push(value);
                        self.$message({
                            message: "扫码成功",
                            type: "success",
                        });
                    } else {
                        self.$message({
                            message: "无对应物料",
                            type: "error",
                        });
                    }
                })
                .finally(() => {
                    this.openScanner = false;
                });
        },
        executeDnOffShelf() {
            this.onDnOffShelf = true;
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/executeDnOffShelf?id=${this.selectIds}`
            this.$_emApiMixin_post(url, {})
                .then(response => {
                    if (response.status === 200) {
                        commonViewsUtil.showSuccess(this, "SAP下架完成");
                        this.$refs.emListFilter.doQuery()
                    } else {
                        commonViewsUtil.showWarning(this, "SAP下架失败");
                    }
                })
                .finally(() => this.onDnOffShelf = false)
        },
        executeDnPost() {
            this.onDnPosting = true;
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/executeDnPost?ids=${this.selectIds}`
            this.$_emApiMixin_post(url, {})
                .then(response => {
                    if (response.status === 200) {
                        commonViewsUtil.showSuccess(this, "SAP过账完成");
                        this.$refs.emListFilter.doQuery()
                    } else {
                        commonViewsUtil.showWarning(this, "SAP过账失败");
                    }
                })
                .finally(() => this.onDnPosting = false)
        },
        clearUpdateTime() {
            this.updateForm.dispatchPlanTime = ''
        },
        clearUpdateRemark() {
            this.updateForm.remark = ''
        },
        updateDispatchTime() {
            let self = this;
            self.$refs["updateTimeForm"].validate(valid => {
                if (valid) {
                    let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/updateDispatchTime?ids=${this.selectIds}&dispatchPlanTime=${self.updateForm.dispatchPlanTime}`
                    self.$_emApiMixin_post(url, {})
                        .then(response => {
                            if (response.status === 200) {
                                self.$message({
                                    message: "更新成功",
                                    type: "success",
                                });

                                self.$refs.emListFilter.doQuery();
                            } else {
                                self.$message({
                                    message: "更新失败",
                                    type: "error",
                                });
                            }
                        })
                        .finally(() => this.updateTimeVisible = false)
                } else {
                    self.$message({
                        message: "数据不完整",
                        type: "error",
                    });
                    return;
                }
            })
        },
        updateRemark() {
            let self = this;
            self.$refs["updateRemarkForm"].validate(valid => {
                if (valid) {
                    let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/updateRemark?ids=${this.selectIds}&remark=${self.updateForm.remark}`
                    self.$_emApiMixin_post(url, {})
                        .then(response => {
                            if (response.status === 200) {
                                self.$message({
                                    message: "更新成功",
                                    type: "success",
                                });

                                self.$refs.emListFilter.doQuery();
                            } else {
                                self.$message({
                                    message: "更新失败",
                                    type: "error",
                                });
                            }
                        })
                        .finally(() => this.updateRemarkVisible = false)
                } else {
                    self.$message({
                        message: "数据不完整",
                        type: "error",
                    });
                    return;
                }
            })
        },
        setUpdateLocation() {
            let locationId = this.$refs.locationTree.getLocationIds();
            let self = this;
            let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/updateDispatchLocation?ids=${this.selectIds}&locationId=${locationId}`
            self.$_emApiMixin_post(url, {})
                .then(response => {
                    if (response.status === 200) {
                        self.$message({
                            message: "更新成功",
                            type: "success",
                        });

                        self.$refs.emListFilter.doQuery();
                    } else {
                        self.$message({
                            message: "更新失败",
                            type: "error",
                        });
                    }
                })
                .finally(() => this.locationSelectModalVisible = false)
        },
        clearUpdateLocation() {
            this.updateLocationForm.locationId = ''
        }
    },
    mounted() {
        if (this.$route.query.idList || this.$route.query.orderNumber && this.$route.query.operationSeq) {
            if (this.$route.query.idList) {
                this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idListFilter', this.$route.query.idList.split(","));
            }
            if (this.$route.query.orderNumber && this.$route.query.operationSeq) {
                this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('orderCodeFilter', this.$route.query.orderNumber);
                this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('operationSeqFilter', this.$route.query.operationSeq);
            }

            this.$refs["emListFilter"].doQuery();
        } else {
            this.initFilter();
        }
    }
};
</script>
